import React from 'react';
import { SectionHeader, SectionWrap, ButtonSecoundry } from '../../Components';
import FieldsShort from '../FieldsShort/FieldsShort';
import './Employee.css';
import { useTranslation } from 'react-i18next';


function Employee() {
  const { t, i18n } = useTranslation();
  
  return (
    <>
    <div className='fieldsPageContainer'>
        <div className='headPage employee'>
        </div>
        <div className='containerNew'>
            <SectionWrap>
            <SectionHeader title={t('fieldsPage5Title')} disc={t('fieldsPageSpan')} />
            <div className='fieldInfo'>
                <span>{t('fieldsPage5Span1')}</span>
                <p>{t('fieldsPage5p1')}</p>
                <span>{t('fieldsPage5Span2')}</span>
                <p>{t('fieldsPage5p2')}</p>
                <ul className='listProperty'>
                    <li>{t('fieldsPage5Li1')}</li>
                    <li>{t('fieldsPage5Li2')}</li>
                    <li>{t('fieldsPage5Li3')}</li>
                    <li>{t('fieldsPage5Li4')}</li>
                    <li>{t('fieldsPage5Li5')}</li>
                </ul>
                <span>{t('fieldsPage5Span3')}</span>
                <p>{t('fieldsPage5p3')}</p>
                <span>{t('fieldsPage5Span4')}</span>
                <p>{t('fieldsPage5p4')}</p>
                <p>{t('fieldsPage5p5')}</p>
            </div>
            <ButtonSecoundry className='askBtnFields' href='/askConsults'>{t('askYourConsult')}</ButtonSecoundry>
        </SectionWrap>
        </div>
        <FieldsShort />
    </div>
    </>
  )
}

export default Employee